module.exports = __webpack_public_path__ + "media/flags/jo-751b1e31.svg";